export const MENU_Z_INDEX_CLASSNAME = "z-[1000]";
